import {Button, Dropdown, MenuProps} from "antd";
import {LANGUAGES} from "../../../utils/languages";
import "./languages-picker.css";
import {useMemo} from "react";
import ArrowDown from "../../../assets/icons/ArrowDown";

interface LanguagePickerProps {
    onClick: (newVal: string) => void;
    selectedKey: string;
    label?: string;
    disabled?: boolean
}

const LanguagePicker = ({ onClick, selectedKey, label = 'Language', disabled = false }: LanguagePickerProps) => {
    const options = useMemo(() => LANGUAGES.map(lang => {
        const flagUrl = `http://purecatamphetamine.github.io/country-flag-icons/3x2/${lang.key.split('-')?.[1].toUpperCase()}.svg`
        return {
            key: lang.key,
            label: <><img src={flagUrl} /> {lang.label}</>
        }
    }), [LANGUAGES]);

    const selected = (options.find(lang => lang.key === selectedKey))?.label || '';

    const languageOptions: MenuProps = {
        onClick: (newVal) => onClick(newVal.key),
        items: options,
        className: 'languages-menu'
    };

    return (
        <div className="languages-selector-container">
            <Dropdown menu={languageOptions} placement="bottomRight" className="languages-selector" trigger={['click']} openClassName="open" >
                <Button className="languages-button" disabled={disabled}>{selected}<div className="dropdown-arrow"><ArrowDown /></div></Button>
            </Dropdown>
            <label>{label}</label>
        </div>
    );
}

export default LanguagePicker;